import { ContactAddressDetails } from '../store/api-generated';

interface Options {
  streetName?: boolean
  houseNumber?: boolean
  postalCode?: boolean
  city?: boolean
}

export default function formatAddress(
  contactAddressDetails: ContactAddressDetails,
  options: Options = {},
) {
  const defaultOptions = {
    streetName: true,
    houseNumber: true,
    houseNumberExtension: true,
    postalCode: true,
    city: true,
  };

  const mergedOptions = {
    ...defaultOptions,
    ...options,
  };

  const hasHouseNumber = mergedOptions.houseNumber && contactAddressDetails.houseNumber;
  const hasExtension = mergedOptions.houseNumberExtension && contactAddressDetails.houseNumberExtension;

  let houseNumberWithExtension = '';
  if (hasHouseNumber) {
    houseNumberWithExtension = contactAddressDetails.houseNumber!;
  }

  if (hasHouseNumber && hasExtension) {
    houseNumberWithExtension += `-${String(contactAddressDetails.houseNumberExtension)}`;
  }

  if (hasHouseNumber && mergedOptions.postalCode) {
    houseNumberWithExtension += ',';
  }

  const houseNumberPart = hasHouseNumber ? houseNumberWithExtension : '';

  return [
    mergedOptions.streetName && contactAddressDetails.streetName,
    houseNumberPart,
    mergedOptions.postalCode && contactAddressDetails.postalCode,
    mergedOptions.city && contactAddressDetails.city,
  ].filter(Boolean).join(' ');
}
